// Recognises the browser refusing Web Storage ("Block all cookies/site data"): a setting on the seller's
// browser, so the boot shows its error screen without reporting the failure.

const SECURITY_ERROR = 'SecurityError'
const WEB_STORAGE = /\b(localStorage|sessionStorage)\b/

/** True for a `SecurityError` whose message names `localStorage` or `sessionStorage`. */
export const isStorageBlockedError = (error: unknown): boolean =>
  error instanceof Error && error.name === SECURITY_ERROR && WEB_STORAGE.test(error.message)
